import React from "react";
import PropTypes from "prop-types";
import { Typography, makeStyles } from "@material-ui/core";
import PhoneValidator from "./PhoneValidator";

const styles = makeStyles((theme) => ({
  wrapper: {
    marginTop: 16,
    marginBottom: 16,
  },
  label: {
    fontSize: 14,
  },
}));

function LabeledPhoneValidator(props) {
  let classes = styles(),
    { label, ...rest } = props;

  return (
    <div className={classes.wrapper}>
      <Typography className={classes.label}>{label}</Typography>
      <PhoneValidator margin="dense" {...rest} />
    </div>
  );
}

LabeledPhoneValidator.propTypes = {
  label: PropTypes.string,
};

export default LabeledPhoneValidator;
